import React, { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';

export interface SocketUser {
  id: number;
  email: string;
}

/**
 * The backend may emit more than these
 * events, but these are the events that
 * the frontend cares about.
 */
export enum EventNames {
  ENTER = 'pt_profile_enter',
  ENTER_ACCOUNT = 'pt_profile_enter_account',
  ENTER_ACCOUNT_SUCCESS = 'pt_profile_enter_account_success',
  LEAVE = 'pt_profile_leave',
  LEAVE_ACCOUNT = 'pt_profile_leave_account',
  LIST = 'pt_profile_list',
  LIST_RESULT = 'pt_profile_list_result'
}

interface ListenEventsMap {
  [EventNames.ENTER]: (user: SocketUser, patientId: number) => void;
  [EventNames.ENTER_ACCOUNT_SUCCESS]: () => void;
  [EventNames.LEAVE]: (user: SocketUser, patientId: number) => void;
  [EventNames.LIST_RESULT]: (users: any) => void;
}

interface EmitEventsMap {
  [EventNames.ENTER]: (patientId: number) => void;
  [EventNames.ENTER_ACCOUNT]: () => void;
  [EventNames.LEAVE]: (patientId: number) => void;
  [EventNames.LEAVE_ACCOUNT]: () => void;
  [EventNames.LIST]: (patientId: number) => void;
}

export type CareSignalSocket = Socket<ListenEventsMap, EmitEventsMap>;

const SocketContext = React.createContext<CareSignalSocket>(null);

export const SocketProvider: React.FC = (props) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socket: CareSignalSocket = io({
      autoConnect: false,
      transports: ['websocket']
    });
    socket.connect();
    setSocket(socket);
    return () => {
      socket.disconnect();
    };
  }, []);

  return <SocketContext.Provider value={socket} {...props} />;
};

export function useSocket(): CareSignalSocket {
  const context = React.useContext(SocketContext);
  if (context === undefined) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
}
